var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.0625H19.4083C18.9575 10.0625 18.732 10.0625 18.5195 9.99813C18.3069 9.93378 18.1194 9.80874 17.7442 9.55865C17.1816 9.18352 16.5397 8.75559 16.2208 8.65904C15.9019 8.5625 15.5638 8.5625 14.8875 8.5625C13.9678 8.5625 13.375 8.5625 12.9616 8.73377C12.5481 8.90504 12.2229 9.2302 11.5726 9.88052L11.0003 10.4528C10.8537 10.5994 10.7805 10.6727 10.7352 10.745C10.5675 11.0132 10.5861 11.3578 10.7817 11.6064C10.8344 11.6734 10.9152 11.7384 11.0766 11.8684C11.6735 12.3487 12.5339 12.3007 13.0744 11.7571L14 10.8259H14.75L19.25 15.3527C19.6642 15.7694 19.6642 16.4449 19.25 16.8616C18.8358 17.2783 18.1642 17.2783 17.75 16.8616L17.375 16.4844M17.375 16.4844L15.125 14.221M17.375 16.4844C17.7892 16.9011 17.7892 17.5767 17.375 17.9933C16.9608 18.41 16.2892 18.41 15.875 17.9933L15.125 17.2389M15.125 17.2389C15.5392 17.6555 15.5392 18.3311 15.125 18.7478C14.7108 19.1644 14.0392 19.1644 13.625 18.7478L12.5 17.616M15.125 17.2389L13.625 15.7389M12.5 17.616L12.125 17.2389M12.5 17.616C12.9142 18.0327 12.9142 18.7083 12.5 19.125C12.0858 19.5417 11.4142 19.5417 11 19.125L8.88228 16.9632C8.44711 16.5189 8.22953 16.2969 7.95076 16.1796C7.672 16.0625 7.36106 16.0625 6.7392 16.0625H6.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16.0625H19.625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 10.0625H6.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.ed5bed26461e46dafcd9d45234a6d4f1.svg";
export { ForwardRef as ReactComponent };